var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "campaign-notification", class: _vm.themeClasses },
    [
      _c("div", { staticClass: "campaign-notification__container" }, [
        _c("div", { staticClass: "campaign-notification__message" }, [
          _c("div", { staticClass: "campaign-notification__icon" }, [
            _c("i", { staticClass: "fa", class: `fa-${_vm.icon}` }),
          ]),
          _vm._v(" "),
          _vm.title
            ? _c("div", { staticClass: "campaign-notification__title" }, [
                _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.heading
            ? _c("div", { staticClass: "campaign-notification__heading" }, [
                _vm._v("\n        " + _vm._s(_vm.heading) + "\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.summary || !!_vm.$slots.summary
            ? _c(
                "div",
                { staticClass: "campaign-notification__summary" },
                [
                  _vm._t("summary", function () {
                    return [_vm._v(_vm._s(_vm.summary))]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.appLinks
            ? _c("div", [
                _c("div", { staticClass: "campaign-notification__app-links" }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-left",
                      attrs: { href: _vm.mobileLink },
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "60px" },
                        attrs: {
                          alt: "Get it on Google Play",
                          src: "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("a", {
                    staticStyle: {
                      display: "inline-block",
                      overflow: "hidden",
                      background:
                        "url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2018-10-06&kind=iossoftware&bubble=ios_apps) no-repeat",
                      width: "135px",
                      height: "40px",
                      "margin-top": "10px",
                    },
                    attrs: { href: _vm.mobileLink },
                  }),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.hasButtons
          ? _c(
              "div",
              { staticClass: "campaign-notification__buttons" },
              [_vm._t("buttons")],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }